export default "__VITE_ASSET__Cmuljcyg__"